import { B2cLoginViewForm } from '../../../../../com/ibm/tw/commons/mvc/b2c.login.viewform';

/**
 * 國內狀 sso viewform.
 */
export class CtwdllinkViewForm extends B2cLoginViewForm {

  /** cib sso token. */
  step2Url: string;

  /** token. */
  token: string;

}
